import { DEFAULT_SHARE_IMAGE } from './constants';

export const normalizeUrl = (url: string): string => {
  try {
    const parsed = new URL(url);
    // Only strip the trailing slash if pathname is not just "/"
    if (parsed.pathname !== '/') {
      parsed.pathname = parsed.pathname.replace(/\/$/, '');
    }
    return parsed.toString();
  } catch {
    return url;
  }
};

export const getImageUrl = (shareImage?: string): string => {
  return shareImage || DEFAULT_SHARE_IMAGE;
};

export const validateSchema = (schema: any) => {
  try {
    JSON.stringify(schema);
    return { isValid: true, schema };
  } catch (error) {
    console.warn('Invalid schema generated:', error, schema);
    return {
      isValid: false,
      schema: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Form Technologies',
        url: '/',
      },
    };
  }
};
